(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !drawer.showModal) {
      return;
    }

    var bodyEl = drawer.querySelector('[data-cart-drawer-body]');
    var surfaceEl = drawer.querySelector('[data-cart-drawer-surface]');
    var closeBtn = drawer.querySelector('[data-cart-drawer-close]');

    function rootPath() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    function removeLineItem(button) {
      var lineKey = button.getAttribute('data-line-key');
      if (!lineKey || button.disabled) {
        return;
      }

      button.disabled = true;

      fetch(rootPath() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('remove failed');
          }
          return window.refreshCartDrawer();
        })
        .catch(function () {
          button.disabled = false;
        });
    }

    function setDrawerOpen(isOpen) {
      document.body.classList.toggle('cart-drawer-open', isOpen);
    }

    function openDrawer() {
      drawer.showModal();
      setDrawerOpen(true);
    }

    function closeDrawer() {
      if (drawer.open) {
        drawer.close();
      }
      setDrawerOpen(false);
    }

    drawer.addEventListener('close', function () {
      setDrawerOpen(false);
    });

    function updateCartCount(count) {
      var cartButton = document.querySelector('[data-cart-drawer-open]');
      var badge = document.querySelector('[data-cart-count]');

      if (count > 0) {
        if (!badge && cartButton) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          badge.setAttribute('data-cart-count', '');
          badge.setAttribute('aria-hidden', 'true');
          cartButton.insertBefore(badge, cartButton.firstChild);
        }
        if (badge) {
          badge.textContent = count;
        }
      } else if (badge) {
        badge.remove();
      }
    }

    function setCartDrawerBody(html) {
      if (!bodyEl || !html) {
        return;
      }

      var template = document.createElement('template');
      template.innerHTML = html.trim();
      var section = template.content.querySelector('.shopify-section');
      bodyEl.innerHTML = section ? section.innerHTML : html;
    }

    window.refreshCartDrawer = function () {
      var sectionUrl = window.location.pathname + '?sections=cart-drawer';
      return fetch(sectionUrl)
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          if (sections['cart-drawer']) {
            setCartDrawerBody(sections['cart-drawer']);
          }
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
        });
    };

    if (surfaceEl) {
      surfaceEl.addEventListener('click', function (event) {
        var removeBtn = event.target.closest('[data-cart-remove]');
        if (removeBtn) {
          event.preventDefault();
          removeLineItem(removeBtn);
        }
        event.stopPropagation();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closeDrawer();
      });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) {
        event.preventDefault();
        openDrawer();
      }
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    drawer.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCollectionFilters() {
    var form = document.getElementById('collection-filters-form');
    if (!form) {
      return;
    }

    var allowedSorts = {
      manual: true,
      'best-selling': true,
      'price-ascending': true,
      'price-descending': true,
      'created-ascending': true,
      'created-descending': true,
      'title-ascending': true,
      'title-descending': true
    };
    var colourParam = form.getAttribute('data-colour-param') || 'filter.v.option.colour';

    function isAllowedSort(value) {
      return Boolean(value && allowedSorts[value]);
    }

    function isAllowedParam(name) {
      if (!name) {
        return false;
      }
      if (name === 'sort_by' || name === 'color' || name === 'size') {
        return true;
      }
      return name.indexOf('filter.') === 0;
    }

    function normalizeParamName(name) {
      if (name === 'size') {
        return 'filter.v.option.size';
      }
      return name;
    }

    function sanitizeSortParam(url) {
      var sortBy = url.searchParams.get('sort_by');
      if (sortBy && !isAllowedSort(sortBy)) {
        if (!url.searchParams.get('color')) {
          url.searchParams.set('color', sortBy);
        }
        url.searchParams.delete('sort_by');
      }
    }

    function selectedColourValues(url) {
      return ['color', 'filter.v.option.color', 'filter.v.option.colour', colourParam]
        .reduce(function (values, key) {
          url.searchParams.getAll(key).forEach(function (value) {
            String(value || '')
              .split(',')
              .forEach(function (part) {
                var normalized = part.trim().toLowerCase();
                if (normalized && values.indexOf(normalized) === -1) {
                  values.push(normalized);
                }
              });
          });
          return values;
        }, []);
    }

    function colourKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function colourMatches(name, selected) {
      var value = String(name || '').trim().toLowerCase();
      if (!value || !selected.length) {
        return false;
      }
      var handle = colourKey(value);
      return selected.some(function (item) {
        var part = String(item || '').trim().toLowerCase();
        var partHandle = colourKey(part);
        return part === value || partHandle === handle || part === handle || partHandle === value;
      });
    }

    function clearColourParams(url) {
      ['color', 'filter.v.option.color', 'filter.v.option.colour', colourParam].forEach(function (key) {
        url.searchParams.delete(key);
      });
    }

    function closeCollectionFilterPanel() {
      var panel = document.querySelector('[data-collection-filter-panel]');
      var toggle = document.querySelector('[data-collection-filter-toggle]');
      var labelOpen = document.querySelector('[data-collection-filter-label-open]');
      var labelClose = document.querySelector('[data-collection-filter-label-close]');

      if (!panel || panel.hidden) {
        return;
      }

      panel.hidden = true;
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
      if (labelOpen) {
        labelOpen.hidden = false;
      }
      if (labelClose) {
        labelClose.hidden = true;
      }
    }

    function revealFilteredProducts() {
      closeCollectionFilterPanel();

      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      var grid = document.querySelector('.collection-page__grid');
      if (!grid) {
        return;
      }

      window.requestAnimationFrame(function () {
        var top = grid.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    function pushColourUrl(url) {
      sanitizeSortParam(url);
      var nextHref = url.pathname + url.search;
      window.history.pushState({ nonaColourFilter: true }, '', nextHref);
      applyColourStateFromUrl(url);
      revealFilteredProducts();
    }

    function syncColourFamilies(selected) {
      form.querySelectorAll('[data-colour-family]').forEach(function (familyEl) {
        var shadeInputs = familyEl.querySelectorAll('[data-collection-filter-input]');
        var anyActive = false;
        shadeInputs.forEach(function (input) {
          if (input.checked) {
            anyActive = true;
          }
        });
        var trigger = familyEl.querySelector('[data-colour-family-trigger]');
        var panel = familyEl.querySelector('.collection-filters__colour-shades');
        var hasMultipleShades = shadeInputs.length > 1;
        familyEl.classList.toggle('is-open', anyActive && hasMultipleShades);
        familyEl.classList.toggle('is-active', anyActive);
        if (trigger) {
          trigger.classList.toggle('collection-filters__option--active', anyActive);
          trigger.setAttribute('aria-expanded', anyActive && hasMultipleShades ? 'true' : 'false');
        }
        if (panel) {
          if (anyActive && hasMultipleShades) {
            panel.hidden = false;
            panel.removeAttribute('hidden');
          } else {
            panel.hidden = true;
            panel.setAttribute('hidden', '');
          }
        }
      });
    }

    function applyColourStateFromUrl(url) {
      var selected = selectedColourValues(url || new URL(window.location.href));
      var activeFamily = null;

      form.querySelectorAll('.collection-filters__options--colour [data-collection-filter-input]').forEach(function (input) {
        var isActive =
          colourMatches(input.value, selected) || colourMatches(input.getAttribute('data-colour-name'), selected);
        input.checked = isActive;
        input.disabled = false;
        var option = input.closest('.collection-filters__option');
        if (option) {
          option.classList.toggle('collection-filters__option--active', isActive);
          option.classList.remove('collection-filters__option--disabled');
        }
      });

      form.querySelectorAll('[data-colour-family]').forEach(function (familyEl) {
        var familyKey = familyEl.getAttribute('data-colour-family');
        var trigger = familyEl.querySelector('[data-colour-family-trigger]');
        var shadeNames = String((trigger && trigger.getAttribute('data-colour-family-shade-names')) || '')
          .split('|||')
          .map(function (part) {
            return part.trim();
          })
          .filter(Boolean);
        if (
          shadeNames.length &&
          selected.length &&
          shadeNames.every(function (shade) {
            return colourMatches(shade, selected);
          }) &&
          selected.every(function (item) {
            return shadeNames.some(function (shade) {
              return colourMatches(shade, [item]);
            });
          })
        ) {
          activeFamily = familyKey;
        }
      });

      syncColourFamilies(selected);

      document.querySelectorAll('.collection-page__grid .product-card').forEach(function (card) {
        var show =
          selected.length === 0 ||
          colourMatches(card.getAttribute('data-card-colour'), selected) ||
          colourMatches(card.getAttribute('data-card-colour-handle'), selected) ||
          (activeFamily && card.getAttribute('data-card-colour-family') === activeFamily);
        card.hidden = !show;
      });
    }

    function restoreColourOptions() {
      var colourList = form.querySelector('.collection-filters__options--colour');
      if (!colourList) {
        applyColourStateFromUrl();
        return;
      }

      var catalogKey =
        'nonaColourFilters:v3:' + (form.getAttribute('data-collection-url') || window.location.pathname);
      var hasColourFilter = selectedColourValues(new URL(window.location.href)).length > 0;

      try {
        if (!hasColourFilter) {
          if (window.sessionStorage) {
            sessionStorage.setItem(catalogKey, colourList.innerHTML);
          }
        } else if (window.sessionStorage) {
          var stored = sessionStorage.getItem(catalogKey);
          var storedCount = stored ? stored.split('data-colour-name=').length - 1 : 0;
          var liveCount = colourList.querySelectorAll('[data-colour-name]').length;
          if (stored && storedCount > liveCount) {
            colourList.innerHTML = stored;
          }
        }
      } catch (storageError) {
        /* Keep the live chip list if storage is blocked. */
      }

      applyColourStateFromUrl();
    }

    function applyColourFamilyClick(trigger) {
      var shades = String(trigger.getAttribute('data-colour-family-shade-names') || '')
        .split('|||')
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean);
      var selected = selectedColourValues(new URL(window.location.href));
      var allFamilySelected =
        shades.length > 0 &&
        shades.every(function (shade) {
          return colourMatches(shade, selected);
        }) &&
        selected.length === shades.length;
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.delete('page');
      clearColourParams(nextUrl);

      if (!allFamilySelected && shades.length) {
        nextUrl.searchParams.set('color', shades.join(','));
      }

      pushColourUrl(nextUrl);
    }

    function applyFilterChange(event) {
      var input = event.target;
      if (!input || !isAllowedParam(input.name)) {
        return;
      }

      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.delete('page');

      if (input.name === 'sort_by') {
        if (!isAllowedSort(input.value)) {
          return;
        }
        nextUrl.searchParams.set('sort_by', input.value);
        sanitizeSortParam(nextUrl);
        window.location.href = nextUrl.pathname + nextUrl.search;
        return;
      }

      var paramName = normalizeParamName(input.name);
      var colourKeys = ['color', 'filter.v.option.color', 'filter.v.option.colour', colourParam];
      var isColourInput = colourKeys.indexOf(input.name) !== -1 || colourKeys.indexOf(paramName) !== -1;
      var currentValues = [];
      var colourFamily = input.getAttribute('data-colour-family');

      if (isColourInput) {
        clearColourParams(nextUrl);
        paramName = 'color';
        if (colourFamily) {
          form
            .querySelectorAll(
              '.collection-filters__options--colour [data-collection-filter-input][data-colour-family="' +
                colourFamily +
                '"]'
            )
            .forEach(function (shadeInput) {
              if (shadeInput.checked && shadeInput.value) {
                currentValues.push(shadeInput.value);
              }
            });
        } else if (input.checked && input.value) {
          currentValues.push(input.value);
        }
      } else {
        currentValues = nextUrl.searchParams.getAll(paramName).filter(function (value) {
          return value !== input.value;
        });
        nextUrl.searchParams.delete(paramName);
        if (input.checked && input.value) {
          currentValues.push(input.value);
        }
      }

      if (paramName === 'color') {
        if (currentValues.length) {
          nextUrl.searchParams.set('color', currentValues.join(','));
        }
      } else {
        currentValues.forEach(function (value) {
          if (value) {
            nextUrl.searchParams.append(paramName, value);
          }
        });
      }

      sanitizeSortParam(nextUrl);

      if (isColourInput) {
        pushColourUrl(nextUrl);
        return;
      }

      window.location.href = nextUrl.pathname + nextUrl.search;
    }

    var currentUrl = new URL(window.location.href);
    var brokenSort = currentUrl.searchParams.get('sort_by');
    if (brokenSort && !isAllowedSort(brokenSort)) {
      sanitizeSortParam(currentUrl);
      window.location.replace(currentUrl.pathname + currentUrl.search);
      return;
    }

    var collectionHandle = String(form.getAttribute('data-collection-handle') || '').toLowerCase();
    var defaultSort = String(form.getAttribute('data-default-sort') || '');
    if (
      (collectionHandle === 'new-arrivals' ||
        collectionHandle === 'new-arrivals-1' ||
        collectionHandle.indexOf('new-arrival') !== -1) &&
      !currentUrl.searchParams.get('sort_by') &&
      defaultSort !== 'manual'
    ) {
      currentUrl.searchParams.set('sort_by', 'manual');
      window.location.replace(currentUrl.pathname + currentUrl.search);
      return;
    }

    restoreColourOptions();

    form.querySelectorAll('[data-collection-filter-input]').forEach(function (input) {
      input.addEventListener('change', applyFilterChange);
    });

    form.querySelectorAll('[data-colour-family-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        applyColourFamilyClick(trigger);
      });
    });

    window.addEventListener('popstate', function () {
      applyColourStateFromUrl();
    });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollectionFilters);
    } else {
      initCollectionFilters();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-page-layout"] && !Shopify.designMode) return;
  try {
    (function () {
    var panel = document.querySelector('[data-collection-filter-panel]');
    var toggle = document.querySelector('[data-collection-filter-toggle]');
    var labelOpen = document.querySelector('[data-collection-filter-label-open]');
    var labelClose = document.querySelector('[data-collection-filter-label-close]');

    if (!panel || !toggle) {
      return;
    }

    function setPanelOpen(isOpen) {
      panel.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (labelOpen) {
        labelOpen.hidden = isOpen;
      }

      if (labelClose) {
        labelClose.hidden = !isOpen;
      }
    }

    toggle.addEventListener('click', function () {
      setPanelOpen(panel.hidden);
    });

    document.addEventListener('click', function (event) {
      if (panel.hidden) {
        return;
      }
      if (panel.contains(event.target) || toggle.contains(event.target)) {
        return;
      }
      setPanelOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        setPanelOpen(false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["color-swatch-utils"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.NonaColorSwatch && window.NonaColorSwatch.colorStyle) {
      return;
    }

    var COLOR_MAP = {
      beige: '#d4c4a8',
      brown: '#6b4423',
      chocolate: '#3d2314',
      purple: '#7a5c8a',
      cream: '#f3ece0',
      white: '#f7f7f7',
      black: '#1a1a1a',
      grey: '#9a9a9a',
      gray: '#9a9a9a',
      navy: '#1e2a44',
      blue: '#4a6fa5',
      green: '#4f6f52',
      red: '#8b3a3a',
      pink: '#d4a5a5',
      orange: '#c67b4b',
      yellow: '#e8d18b',
      dirtybeige: '#c9b896',
      'dirty beige': '#c9b896',
      'tie-dye': 'linear-gradient(135deg, #6b4423 0%, #d4c4a8 50%, #8b7355 100%)',
      'tie dye': 'linear-gradient(135deg, #6b4423 0%, #d4c4a8 50%, #8b7355 100%)'
    };

    function parseColorInput(input) {
      var raw = String(input || '').trim();
      if (!raw) {
        return null;
      }

      if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(raw)) {
        return raw;
      }

      if (/^rgb/i.test(raw)) {
        return raw;
      }

      if (/^[0-9a-f]{3}$/i.test(raw) || /^[0-9a-f]{6}$/i.test(raw)) {
        return '#' + raw;
      }

      return null;
    }

    function colorValue(colorName, hexOverride) {
      var direct = parseColorInput(hexOverride) || parseColorInput(colorName);
      if (direct) {
        return direct;
      }

      var key = String(colorName || '').toLowerCase().trim();
      var value = COLOR_MAP[key];

      if (!value) {
        Object.keys(COLOR_MAP).forEach(function (mapKey) {
          if (value) {
            return;
          }
          if (key.indexOf(mapKey) !== -1 || mapKey.indexOf(key) !== -1) {
            value = COLOR_MAP[mapKey];
          }
        });
      }

      return value || '#e8e4dc';
    }

    function colorStyle(colorName, hexOverride) {
      var fill = colorValue(colorName, hexOverride);
      if (fill.indexOf('gradient') !== -1) {
        return 'background: ' + fill + ';';
      }
      return 'background-color: ' + fill + ';';
    }

    function applySwatch(el, colorName) {
      if (!el) {
        return;
      }

      el.style.setProperty(
        '--swatch-fill',
        colorValue(colorName, el.getAttribute('data-swatch-hex'))
      );
    }

    function normalizeColorLabel(value) {
      return String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function altMatchesColor(alt, color) {
      var normalizedAlt = normalizeColorLabel(alt);
      var normalizedColor = normalizeColorLabel(color);
      if (!normalizedAlt || !normalizedColor) {
        return false;
      }
      if (normalizedAlt === normalizedColor) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + ' /') === 0) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + '/') === 0) {
        return true;
      }
      var suffix = ' / ' + normalizedColor;
      if (normalizedAlt.length >= suffix.length) {
        if (normalizedAlt.slice(-suffix.length) === suffix) {
          return true;
        }
      }
      var tightSuffix = '/' + normalizedColor;
      if (normalizedAlt.length >= tightSuffix.length) {
        if (normalizedAlt.slice(-tightSuffix.length) === tightSuffix) {
          return true;
        }
      }
      var parts = normalizedAlt.split(/\s*\/\s*/);
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === normalizedColor) {
          return true;
        }
      }
      return false;
    }

    window.NonaColorSwatch = {
      colorValue: colorValue,
      colorStyle: colorStyle,
      applySwatch: applySwatch,
      parseColorInput: parseColorInput
    };

    window.NonaColorMedia = {
      normalizeColorLabel: normalizeColorLabel,
      altMatchesColor: altMatchesColor
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    var menuToggle = document.querySelector('.header-strip__menu-toggle');
    var headerLogo = document.querySelector('.header__logo');
    if (!menuToggle && !headerLogo) {
      return;
    }

    var lastScrollY = window.scrollY;
    var scrollThreshold = 10;
    var scrollHidden = false;
    var ticking = false;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function isFullMenuOpen() {
      return document.body.classList.contains('header-fullmenu-open');
    }

    function isMobile() {
      return mobileQuery.matches;
    }

    function applyScrollHidden() {
      var hideMenu = scrollHidden && !isFullMenuOpen();
      var hideLogo = hideMenu && isMobile();

      if (menuToggle) {
        menuToggle.classList.toggle('header-strip__menu-toggle--scroll-hidden', hideMenu);
      }

      if (headerLogo) {
        headerLogo.classList.toggle('header__logo--scroll-hidden', hideLogo);
      }
    }

    function updateScrollHidden() {
      var currentScrollY = window.scrollY;

      if (isFullMenuOpen() || currentScrollY <= scrollThreshold) {
        scrollHidden = false;
      } else if (currentScrollY > lastScrollY + scrollThreshold) {
        scrollHidden = true;
      } else if (currentScrollY < lastScrollY - scrollThreshold) {
        scrollHidden = false;
      }

      applyScrollHidden();
      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateScrollHidden);
          ticking = true;
        }
      },
      { passive: true }
    );

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', applyScrollHidden);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(applyScrollHidden);
    }

    var bodyClassObserver = new MutationObserver(function () {
      applyScrollHidden();
    });

    bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-quick-view]');
    if (!dialog || (typeof dialog.showModal !== 'function' && typeof dialog.show !== 'function')) {
      return;
    }

    var stringsEl = document.querySelector('[data-quick-view-strings]');
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    var bodyEl = dialog.querySelector('[data-quick-view-body]');
    var loadingEl = dialog.querySelector('[data-quick-view-loading]');
    var errorEl = dialog.querySelector('[data-quick-view-error]');
    var mediaEl = dialog.querySelector('[data-quick-view-media]');
    var mediaFrameEl = dialog.querySelector('[data-quick-view-media-inner]');
    var mediaScrollEl = dialog.querySelector('[data-quick-view-media-scroll]');
    var mediaDotsEl = dialog.querySelector('[data-quick-view-media-dots]');
    var titleEl = dialog.querySelector('[data-quick-view-product-title]');
    var priceAmountEl = dialog.querySelector('[data-quick-view-price-amount]');
    var priceCurrencyEl = dialog.querySelector('[data-quick-view-price-currency]');
    var colourRow = dialog.querySelector('[data-quick-view-colour-row]');
    var colourNameEl = dialog.querySelector('[data-quick-view-colour-name]');
    var swatchesEl = dialog.querySelector('[data-quick-view-swatches]');
    var sizeRow = dialog.querySelector('[data-quick-view-size-row]');
    var sizesEl = dialog.querySelector('[data-quick-view-sizes]');
    var addBtn = dialog.querySelector('[data-quick-view-add]');

    var panelEl = dialog.querySelector('[data-quick-view-panel]');
    var closeBtn = dialog.querySelector('[data-quick-view-close]');
    var state = {
      product: null,
      availabilityVariants: [],
      variantId: null,
      colorOptionIndex: null,
      sizeOptionIndex: null,
      colorValues: [],
      colorSwatches: {},
      colorImages: {},
      images: [],
      colorImageSets: {},
      sizeValues: [],
      selectedColor: null,
      selectedSize: null,
      useColorProperties: false,
      useSizeProperties: false,
      adding: false
    };
    var openId = 0;
    var fetchController = null;
    var defaultSizes = strings.defaultSizes || ['One Size'];

    function isMobileQuickView() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function openQuickViewDialog() {
      if (isMobileQuickView() && typeof dialog.show === 'function') {
        dialog.show();
        return;
      }

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    function rootPath() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    function formatMoneyWithoutCurrency(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function' &&
        strings.moneyWithoutCurrencyFormat
      ) {
        return window.Shopify.formatMoney(cents, strings.moneyWithoutCurrencyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function parseCardData(cardRoot) {
      var dataEl = null;
      if (cardRoot) {
        if (cardRoot.matches && cardRoot.matches('[data-quick-view-data]')) {
          dataEl = cardRoot;
        } else {
          dataEl = cardRoot.querySelector('[data-quick-view-data]');
        }
      }
      if (!dataEl) {
        return {
          variantId: null,
          colors: [],
          colorSwatches: {},
          colorImages: {},
          images: [],
          colorImageSets: {},
          sizes: [],
          variants: [],
          colorOptionIndex: null,
          sizeOptionIndex: null
        };
      }
      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        return {
          variantId: null,
          colors: [],
          colorSwatches: {},
          colorImages: {},
          images: [],
          colorImageSets: {},
          sizes: [],
          variants: [],
          colorOptionIndex: null,
          sizeOptionIndex: null
        };
      }
    }

    function optionNameAt(product, index) {
      if (!product || !product.options || index == null) {
        return '';
      }
      var opt = product.options[index];
      if (typeof opt === 'string') {
        return opt;
      }
      if (opt && opt.name) {
        return String(opt.name);
      }
      return '';
    }

    function optionIndexFromProduct(product, matcher) {
      if (!product || !product.options) {
        return null;
      }
      for (var i = 0; i < product.options.length; i += 1) {
        if (matcher(optionNameAt(product, i))) {
          return i;
        }
      }
      return null;
    }

    function optionValuesFromProduct(product, optionIndex) {
      if (optionIndex == null || !product || !product.variants) {
        return [];
      }
      var values = [];
      var optionDef = product.options && product.options[optionIndex];
      if (optionDef && optionDef.values && optionDef.values.length) {
        optionDef.values.forEach(function (value) {
          var label = String(value || '').trim();
          if (label && values.indexOf(label) === -1) {
            values.push(label);
          }
        });
        if (values.length) {
          return values;
        }
      }
      product.variants.forEach(function (variant) {
        var value = optionValue(variant, optionIndex);
        if (value && values.indexOf(value) === -1) {
          values.push(value);
        }
      });
      return values;
    }

    function optionValue(variant, index) {
      if (!variant || index == null) {
        return null;
      }
      if (index === 0) {
        return variant.option1;
      }
      if (index === 1) {
        return variant.option2;
      }
      if (index === 2) {
        return variant.option3;
      }
      return null;
    }

    function normalizeOptionLabel(value) {
      return String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function optionLabelsMatch(a, b) {
      if (a == null || b == null) {
        return false;
      }
      return normalizeOptionLabel(a) === normalizeOptionLabel(b);
    }

    function variantsForAvailability() {
      if (state.availabilityVariants && state.availabilityVariants.length) {
        return state.availabilityVariants;
      }
      if (state.product && state.product.variants) {
        return state.product.variants;
      }
      return [];
    }

    var colorSwatch = window.NonaColorSwatch || {};

    function applySwatchColor(element, colorName, hexOverride) {
      if (!element) {
        return;
      }
      var fill = colorSwatch.colorValue
        ? colorSwatch.colorValue(colorName, hexOverride)
        : '#e8e4dc';
      element.style.setProperty('--swatch-fill', fill);
    }

    function normalizeColorLabel(value) {
      return String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function altMatchesColor(alt, color) {
      var normalizedAlt = normalizeColorLabel(alt);
      var normalizedColor = normalizeColorLabel(color);
      if (!normalizedAlt || !normalizedColor) {
        return false;
      }
      if (normalizedAlt === normalizedColor) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + ' /') === 0) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + '/') === 0) {
        return true;
      }
      return normalizedAlt.split(/\s*\/\s*/).some(function (part) {
        return part === normalizedColor;
      });
    }

    function imagesFromProduct(product) {
      if (!product || !product.images || !product.images.length) {
        return [];
      }
      return product.images.map(function (entry, index) {
        if (typeof entry === 'string') {
          return { id: 'img-' + index, src: entry, alt: '' };
        }
        return {
          id: entry.id || 'img-' + index,
          src: entry.src || '',
          alt: entry.alt || ''
        };
      });
    }

    function collectImages() {
      var seen = {};
      var images = [];

      function addImage(image) {
        if (!image || !image.src) {
          return;
        }
        var key = String(image.src).split('?')[0];
        if (seen[key]) {
          return;
        }
        seen[key] = true;
        images.push(image);
      }

      (state.images || []).forEach(addImage);
      imagesFromProduct(state.product).forEach(addImage);

      return images;
    }

    function imagesForColor(color) {
      var sets = state.colorImageSets || {};
      if (color && sets[color] && sets[color].length) {
        return sets[color];
      }
      if (color) {
        var colorKey = normalizeColorLabel(color);
        var setKeys = Object.keys(sets);
        for (var i = 0; i < setKeys.length; i += 1) {
          if (normalizeColorLabel(setKeys[i]) === colorKey && sets[setKeys[i]].length) {
            return sets[setKeys[i]];
          }
        }
      }

      var images = collectImages();
      if (!color) {
        return images;
      }

      var matched = images.filter(function (image) {
        return altMatchesColor(image.alt, color);
      });
      if (matched.length) {
        return matched;
      }

      var variant = findVariant();
      var featuredSrc = variantImageSrc(variant) || imageSrcForSelection(variant);
      if (featuredSrc) {
        var featured = images.filter(function (image) {
          return image.src && image.src.split('?')[0] === featuredSrc.split('?')[0];
        });
        if (featured.length) {
          return featured;
        }
        return [{ id: 'featured', src: featuredSrc, alt: color }];
      }

      return [];
    }

    function imagesForSelection() {
      return imagesForColor(state.selectedColor);
    }

    function galleryDotLabel(index, count) {
      return String(strings.mediaGalleryDot || 'Show image {{ index }} of {{ count }}')
        .replace('{{ index }}', String(index))
        .replace('{{ count }}', String(count));
    }

    function updateGalleryDots(activeId) {
      if (!mediaDotsEl) {
        return;
      }
      mediaDotsEl.querySelectorAll('[data-quick-view-media-dot]').forEach(function (dot) {
        dot.classList.toggle('is-active', String(dot.getAttribute('data-media-id')) === String(activeId));
      });
    }

    function scrollGalleryTo(mediaId) {
      if (!mediaFrameEl || !mediaScrollEl) {
        return;
      }
      var slide = mediaScrollEl.querySelector(
        '[data-quick-view-media-slide][data-media-id="' + mediaId + '"]'
      );
      if (!slide) {
        return;
      }
      var targetLeft =
        slide.getBoundingClientRect().left -
        mediaFrameEl.getBoundingClientRect().left +
        mediaFrameEl.scrollLeft;
      mediaFrameEl.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
      updateGalleryDots(mediaId);
    }

    function syncGalleryDotsFromScroll() {
      if (!mediaFrameEl || !mediaScrollEl) {
        return;
      }
      var slides = mediaScrollEl.querySelectorAll('[data-quick-view-media-slide]');
      if (!slides.length) {
        return;
      }
      var frameLeft = mediaFrameEl.getBoundingClientRect().left;
      var closestSlide = slides[0];
      var closestDistance = Infinity;
      slides.forEach(function (slide) {
        var distance = Math.abs(slide.getBoundingClientRect().left - frameLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });
      if (closestSlide) {
        updateGalleryDots(closestSlide.getAttribute('data-media-id'));
      }
    }

    function renderGallery() {
      if (!mediaScrollEl) {
        return;
      }
      var images = imagesForSelection();
      mediaScrollEl.innerHTML = '';
      if (mediaDotsEl) {
        mediaDotsEl.innerHTML = '';
      }
      if (!images.length) {
        if (mediaDotsEl) {
          mediaDotsEl.hidden = true;
        }
        return;
      }

      images.forEach(function (image, index) {
        var slide = document.createElement('div');
        slide.className = 'quick-view__media-slide';
        slide.setAttribute('data-quick-view-media-slide', '');
        slide.setAttribute('data-media-id', image.id);
        var img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || '';
        img.loading = index === 0 ? 'eager' : 'lazy';
        img.decoding = 'async';
        slide.appendChild(img);
        mediaScrollEl.appendChild(slide);

        if (mediaDotsEl && images.length > 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'quick-view__media-dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('data-quick-view-media-dot', '');
          dot.setAttribute('data-media-id', image.id);
          dot.setAttribute('aria-label', galleryDotLabel(index + 1, images.length));
          mediaDotsEl.appendChild(dot);
        }
      });

      if (mediaDotsEl) {
        mediaDotsEl.hidden = images.length < 2;
      }
      if (mediaFrameEl) {
        mediaFrameEl.scrollLeft = 0;
      }
    }

    function setLoading(isLoading) {
      loadingEl.hidden = !isLoading;
      if (isLoading) {
        bodyEl.hidden = true;
        errorEl.hidden = true;
      }
    }

    function setError(message) {
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    function isQuickViewActive(sessionId) {
      return sessionId === openId && dialog.open;
    }

    function resetQuickView() {
      state.product = null;
      state.availabilityVariants = [];
      state.variantId = null;
      state.colorOptionIndex = null;
      state.sizeOptionIndex = null;
      state.colorValues = [];
      state.colorSwatches = {};
      state.colorImages = {};
      state.images = [];
      state.colorImageSets = {};
      state.sizeValues = [];
      state.selectedColor = null;
      state.selectedSize = null;
      state.useColorProperties = false;
      state.useSizeProperties = false;
      state.adding = false;
      bodyEl.hidden = true;
      loadingEl.hidden = true;
      errorEl.hidden = true;
      errorEl.textContent = '';
      if (mediaScrollEl) {
        mediaScrollEl.innerHTML = '';
      }
      if (mediaDotsEl) {
        mediaDotsEl.innerHTML = '';
        mediaDotsEl.hidden = true;
      }
      titleEl.textContent = '';
      priceAmountEl.textContent = '';
      priceCurrencyEl.textContent = '';
      colourNameEl.textContent = '';
      if (swatchesEl) {
        swatchesEl.innerHTML = '';
      }
      sizesEl.innerHTML = '';
      colourRow.hidden = true;
      sizeRow.hidden = false;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = strings.addToCart || 'Add to Cart';
      }
    }

    function abortPendingFetch() {
      if (fetchController) {
        fetchController.abort();
        fetchController = null;
      }
    }

    function findVariant() {
      var variants = variantsForAvailability();
      if (!variants.length) {
        return null;
      }

      return (
        variants.find(function (variant) {
          if (state.colorOptionIndex != null && state.selectedColor) {
            if (!optionLabelsMatch(optionValue(variant, state.colorOptionIndex), state.selectedColor)) {
              return false;
            }
          }
          if (state.sizeOptionIndex != null && state.selectedSize) {
            if (!optionLabelsMatch(optionValue(variant, state.sizeOptionIndex), state.selectedSize)) {
              return false;
            }
          }
          return true;
        }) || null
      );
    }

    function variantImageSrc(variant) {
      if (!variant || !variant.featured_image) {
        return null;
      }
      return variant.featured_image.src || null;
    }

    function imageSrcForSelection(preferredVariant) {
      if (
        state.selectedColor &&
        state.colorImages &&
        state.colorImages[state.selectedColor]
      ) {
        return state.colorImages[state.selectedColor];
      }

      var src = variantImageSrc(preferredVariant);
      if (src) {
        return src;
      }

      if (state.product && state.product.variants && state.colorOptionIndex != null && state.selectedColor) {
        var colorVariantWithImage = state.product.variants.find(function (variant) {
          if (!optionLabelsMatch(optionValue(variant, state.colorOptionIndex), state.selectedColor)) {
            return false;
          }
          return Boolean(variantImageSrc(variant));
        });
        src = variantImageSrc(colorVariantWithImage);
        if (src) {
          return src;
        }
      }

      if (state.product && state.product.media && state.selectedColor) {
        var mediaMatch = state.product.media.find(function (entry) {
          if (!entry || entry.media_type !== 'image') {
            return false;
          }
          var alt = entry.alt || '';
          return alt === state.selectedColor || alt.indexOf(state.selectedColor) !== -1;
        });
        if (mediaMatch && mediaMatch.src) {
          return mediaMatch.src;
        }
      }

      return (state.product && state.product.featured_image) || null;
    }

    function isSizeAvailable(sizeValue) {
      var variants = variantsForAvailability();
      if (!variants.length) {
        return true;
      }

      return variants.some(function (variant) {
        if (!variant.available) {
          return false;
        }

        var sizeMatches = false;
        if (state.sizeOptionIndex != null) {
          sizeMatches = optionLabelsMatch(optionValue(variant, state.sizeOptionIndex), sizeValue);
        } else {
          sizeMatches =
            optionLabelsMatch(variant.option1, sizeValue) ||
            optionLabelsMatch(variant.option2, sizeValue) ||
            optionLabelsMatch(variant.option3, sizeValue);
        }
        if (!sizeMatches) {
          return false;
        }

        if (state.colorOptionIndex != null && state.selectedColor) {
          return optionLabelsMatch(optionValue(variant, state.colorOptionIndex), state.selectedColor);
        }

        return true;
      });
    }

    function syncSelectionUi() {
      var variant = findVariant();
      if (variant) {
        state.variantId = variant.id;
        priceAmountEl.textContent = formatMoneyWithoutCurrency(variant.price);
      } else if (state.product) {
        if (!state.useColorProperties && !state.useSizeProperties) {
          state.variantId = state.product.variants[0] && state.product.variants[0].id;
        }
        priceAmountEl.textContent = formatMoneyWithoutCurrency(state.product.price);
      }

      renderGallery();

      var canAdd = Boolean(state.variantId) && !state.adding;
      if (state.sizeValues.length && !state.selectedSize) {
        canAdd = false;
      }
      if (variant && !variant.available) {
        canAdd = false;
      }

      if (addBtn) {
        addBtn.disabled = !canAdd;
        if (variant && !variant.available) {
          addBtn.textContent = strings.soldOut || 'Sold out';
        } else {
          addBtn.textContent = strings.addToCart || 'Add to Cart';
        }
      }
    }

    function renderSizes() {
      sizesEl.innerHTML = '';
      sizeRow.hidden = false;

      state.sizeValues.forEach(function (sizeValue) {
        var button = document.createElement('button');
        button.type = 'button';
        var isOneSize =
          state.sizeValues.length === 1 &&
          /one size/i.test(sizeValue);
        button.className = isOneSize
          ? 'quick-view__size quick-view__size--one-size'
          : 'quick-view__size';
        button.textContent = sizeValue;
        button.setAttribute('aria-pressed', state.selectedSize === sizeValue ? 'true' : 'false');
        button.disabled = !isSizeAvailable(sizeValue);
        button.addEventListener('click', function () {
          if (state.adding || button.disabled) {
            return;
          }
          state.selectedSize = sizeValue;
          renderSizes();
          syncSelectionUi();
        });
        sizesEl.appendChild(button);
      });
    }

    function renderColours() {
      if (!swatchesEl) {
        return;
      }

      swatchesEl.innerHTML = '';

      if (!state.colorValues.length) {
        colourRow.hidden = true;
        return;
      }

      colourRow.hidden = false;
      if (!state.selectedColor) {
        state.selectedColor = state.colorValues[0];
      }

      colourNameEl.textContent = state.selectedColor;

      state.colorValues.forEach(function (colorValue) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'quick-view__swatch-btn';
        button.setAttribute('aria-label', colorValue);
        button.setAttribute('aria-pressed', state.selectedColor === colorValue ? 'true' : 'false');

        var swatch = document.createElement('span');
        swatch.className = 'quick-view__swatch';
        swatch.setAttribute('aria-hidden', 'true');
        applySwatchColor(
          swatch,
          colorValue,
          state.colorSwatches ? state.colorSwatches[colorValue] : null
        );
        button.appendChild(swatch);

        button.addEventListener('click', function () {
          if (state.adding) {
            return;
          }
          state.selectedColor = colorValue;
          if (state.selectedSize && !isSizeAvailable(state.selectedSize)) {
            state.selectedSize = null;
          }
          renderColours();
          renderSizes();
          syncSelectionUi();
        });

        swatchesEl.appendChild(button);
      });
    }

    function renderProduct(product, cardData) {
      state.product = product;
      state.availabilityVariants =
        cardData.variants && cardData.variants.length
          ? cardData.variants
          : product && product.variants
            ? product.variants
            : [];

      var jsColorIndex = optionIndexFromProduct(product, function (name) {
        return /color|colour/i.test(name);
      });
      var jsSizeIndex = optionIndexFromProduct(product, function (name) {
        return /^size$/i.test(name) || /size/i.test(name);
      });

      state.colorOptionIndex =
        cardData.colorOptionIndex != null ? cardData.colorOptionIndex : jsColorIndex;
      state.sizeOptionIndex =
        cardData.sizeOptionIndex != null ? cardData.sizeOptionIndex : jsSizeIndex;

      var optionColors =
        state.colorOptionIndex != null ? optionValuesFromProduct(product, state.colorOptionIndex) : [];
      var optionSizes =
        state.sizeOptionIndex != null ? optionValuesFromProduct(product, state.sizeOptionIndex) : [];

      state.colorValues =
        cardData.colors && cardData.colors.length
          ? cardData.colors
          : optionColors;
      state.colorSwatches = cardData.colorSwatches || {};
      state.colorImages = cardData.colorImages || {};
      state.images = cardData.images && cardData.images.length
        ? cardData.images
        : imagesFromProduct(product);
      state.colorImageSets = cardData.colorImageSets || {};

      // Prefer Size option values (same as product page) when a size option exists.
      if (state.sizeOptionIndex != null && optionSizes.length) {
        state.sizeValues = optionSizes;
      } else if (cardData.sizes && cardData.sizes.length) {
        state.sizeValues = cardData.sizes;
      } else {
        state.sizeValues = defaultSizes.slice();
      }

      state.useColorProperties =
        state.colorOptionIndex == null && state.colorValues.length > 0;
      state.useSizeProperties = state.sizeOptionIndex == null && state.sizeValues.length > 0;

      var initialVariant =
        (cardData.variantId &&
          state.availabilityVariants.find(function (variant) {
            return String(variant.id) === String(cardData.variantId);
          })) ||
        state.availabilityVariants.find(function (variant) {
          return variant.available;
        }) ||
        state.availabilityVariants[0] ||
        null;

      state.variantId = initialVariant ? initialVariant.id : null;
      state.selectedColor = null;
      state.selectedSize = null;

      if (initialVariant && state.colorOptionIndex != null) {
        state.selectedColor = optionValue(initialVariant, state.colorOptionIndex);
      }
      if (!state.selectedColor && state.colorValues.length) {
        state.selectedColor = state.colorValues[0];
      }

      titleEl.textContent = product.title;
      priceCurrencyEl.textContent = strings.currencyCode || '';

      renderColours();
      renderSizes();
      syncSelectionUi();

      bodyEl.hidden = false;
      loadingEl.hidden = true;
    }

    function addToCart() {
      if (!state.variantId || state.adding) {
        return;
      }

      if (state.sizeValues.length && !state.selectedSize) {
        return;
      }

      var variant = findVariant();
      if (variant && !variant.available) {
        return;
      }

      state.adding = true;
      setError('');
      if (addBtn) {
        addBtn.disabled = true;
      }

      var properties = {};
      if (state.useColorProperties && state.selectedColor) {
        properties.Color = state.selectedColor;
      }
      if (state.useSizeProperties && state.selectedSize) {
        properties.Size = state.selectedSize;
      }

      var item = { id: state.variantId, quantity: 1 };
      if (Object.keys(properties).length) {
        item.properties = properties;
      }

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add failed');
          }
          return response.json();
        })
        .then(function () {
          closeQuickView();
          if (typeof window.refreshCartDrawer === 'function') {
            return window.refreshCartDrawer();
          }
        })
        .then(function () {
          var cartDrawer = document.querySelector('[data-cart-drawer]');
          if (cartDrawer && cartDrawer.showModal) {
            cartDrawer.showModal();
          }
        })
        .catch(function () {
          setError(strings.addError || 'Could not add to cart.');
        })
        .finally(function () {
          state.adding = false;
          syncSelectionUi();
        });
    }

    function openQuickView(handle, cardRoot) {
      if (!handle) {
        return;
      }

      abortPendingFetch();
      openId += 1;
      var sessionId = openId;
      fetchController = new AbortController();

      var cardData = parseCardData(cardRoot);
      resetQuickView();
      setLoading(true);
      openQuickViewDialog();

      fetch(rootPath() + 'products/' + encodeURIComponent(handle) + '.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: fetchController.signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('fetch failed');
          }
          return response.json();
        })
        .then(function (product) {
          if (!isQuickViewActive(sessionId)) {
            return;
          }
          renderProduct(product, cardData);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') {
            return;
          }
          if (!isQuickViewActive(sessionId)) {
            return;
          }
          setError(strings.loadError || strings.addError || 'Could not load product.');
        })
        .finally(function () {
          if (!isQuickViewActive(sessionId)) {
            return;
          }
          setLoading(false);
          if (sessionId === openId) {
            fetchController = null;
          }
        });
    }

    function closeQuickView() {
      openId += 1;
      abortPendingFetch();
      resetQuickView();
      if (dialog.open) {
        dialog.close();
      }
    }

    if (panelEl) {
      panelEl.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closeQuickView();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart();
      });
    }

    if (mediaFrameEl) {
      var galleryScrollTicking = false;
      mediaFrameEl.addEventListener(
        'scroll',
        function () {
          if (galleryScrollTicking) {
            return;
          }
          galleryScrollTicking = true;
          window.requestAnimationFrame(function () {
            syncGalleryDotsFromScroll();
            galleryScrollTicking = false;
          });
        },
        { passive: true }
      );
    }

    if (mediaDotsEl) {
      mediaDotsEl.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-quick-view-media-dot]');
        if (!dot) {
          return;
        }
        scrollGalleryTo(dot.getAttribute('data-media-id'));
      });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-quick-view-open]');
      if (openTrigger) {
        event.preventDefault();
        openQuickView(
          openTrigger.getAttribute('data-product-handle'),
          openTrigger.closest('.product-card') || openTrigger.closest('[data-quick-view-data]')
        );
      }
    });

    dialog.addEventListener('click', function (event) {
      if (!isMobileQuickView() && event.target === dialog) {
        closeQuickView();
      }
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeQuickView();
    });

    dialog.addEventListener('close', function () {
      openId += 1;
      abortPendingFetch();
      resetQuickView();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var FALLBACK_PATH = '/collections/new-arrivals';

    function normalizeLabel(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isNewClothingLabel(label) {
      return (
        label === 'new clothing' ||
        label.indexOf('new clothing') !== -1 ||
        label === 'new arrivals' ||
        label.indexOf('new arrival') !== -1 ||
        label === 'home page' ||
        label.indexOf('home page') !== -1
      );
    }

    function shopifyRootPath(suffix) {
      var root = '/';
      try {
        if (window.Shopify && Shopify.routes && Shopify.routes.root) {
          root = String(Shopify.routes.root);
        }
      } catch (error) {
        /* Ignore. */
      }
      if (!root || root === '/') {
        return suffix;
      }
      var normalized = root.slice(-1) === '/' ? root.slice(0, -1) : root;
      return normalized + suffix;
    }

    function resolveNewClothingUrl(link) {
      var fromLink = link && link.getAttribute('data-new-clothing-url');
      if (fromLink && fromLink.charAt(0) === '/') {
        return fromLink;
      }

      var menu = document.querySelector('[data-header-shop-menu]');
      var fromMenu = menu && menu.getAttribute('data-new-clothing-url');
      if (fromMenu && fromMenu.charAt(0) === '/') {
        return fromMenu;
      }

      return shopifyRootPath(FALLBACK_PATH);
    }

    function hrefLooksLikeHomePage(href) {
      var value = String(href || '').toLowerCase();
      return (
        value.indexOf('/pages/home-page') !== -1 ||
        value.indexOf('/pages/new-clothing') !== -1 ||
        value.indexOf('/collections/new-clothing') !== -1 ||
        value === '/' ||
        value === '#'
      );
    }

    function isNewClothingAnchor(anchor) {
      if (!anchor || anchor.tagName !== 'A') {
        return false;
      }
      if (anchor.hasAttribute('data-new-clothing-link')) {
        return true;
      }
      if (anchor.classList.contains('shop-menu__link--new-clothing')) {
        return true;
      }
      if (anchor.classList.contains('shop-menu__link') && isNewClothingLabel(normalizeLabel(anchor.textContent))) {
        return true;
      }
      if (anchor.classList.contains('shop-menu__link') && hrefLooksLikeHomePage(anchor.getAttribute('href'))) {
        return true;
      }
      return false;
    }

    function hardenAnchors() {
      var preferred = resolveNewClothingUrl(null);
      document.querySelectorAll('.shop-menu__link').forEach(function (link) {
        var labelMatch = isNewClothingLabel(normalizeLabel(link.textContent));
        var hrefMatch = hrefLooksLikeHomePage(link.getAttribute('href'));
        if (!labelMatch && !hrefMatch && !link.hasAttribute('data-new-clothing-link')) {
          return;
        }
        link.setAttribute('data-new-clothing-link', '');
        link.setAttribute('data-new-clothing-url', preferred);
        link.setAttribute('href', preferred);
        link.classList.add('shop-menu__link--new-clothing');
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var anchor = event.target && event.target.closest ? event.target.closest('a.shop-menu__link') : null;
        if (!anchor) {
          return;
        }
        if (!isNewClothingAnchor(anchor) && !hrefLooksLikeHomePage(anchor.getAttribute('href'))) {
          return;
        }

        var url = resolveNewClothingUrl(anchor);
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(url);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hardenAnchors);
    } else {
      hardenAnchors();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ui-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    var selector =
      'button, a, summary, [role="button"], input[type="button"], input[type="submit"], input[type="reset"]';

    function blurTapTarget(event) {
      var target = event.target.closest(selector);
      if (!target) {
        return;
      }

      window.requestAnimationFrame(function () {
        if (typeof target.blur === 'function') {
          target.blur();
        }
      });
    }

    document.addEventListener('touchend', blurTapTarget, { passive: true });
    document.addEventListener('mouseup', blurTapTarget);
  })();
  } catch(e) { console.error(e); }
})();

})();
